import React from 'react';
import { Form, Row, Upload } from 'antd';
import { UploadFileIcon } from '../../assets/icons';


const { Dragger } = Upload;

const UploadBox = ({
    draggerProps,
    draggerRef,
    disabled,
    borderColor,
}) => (
    <Form.Item name="files" noStyle className="fileDragger">
        <Dragger
            {...draggerProps}
            showUploadList={false}
            style={{ borderColor, }}
            ref={draggerRef}
            disabled={disabled}
            accept=".MP4,.MOV,.WMV,.AVI,.AVCHD,.FLV,.F4V,.SWF,.MKV,.WEBM,.HTML5"
        >
            <Row
                align="middle"
                style={{
                    flexDirection: 'column', width: "218px",
                    height: "70px", justifyContent: "center"
                }}

            >
                <div style={{ height: 25, width: 25, marginBottom: 10 }}>
                    <UploadFileIcon />
                </div>
                <p className="ant-upload-text">Click or drag file to upload</p>
            </Row>
        </Dragger>
    </Form.Item>
);

export default UploadBox;
